var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d_details_container"},[_c('div',{staticClass:"d_content_container"},[_c('h4',[_vm._v("Campaign details")]),_c('DetailsTablet',{attrs:{"preloading":_vm.preloading,"campaign-detail":_vm.campaignDetail}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }